export default {"src":"__ASTRO_ASSET_IMAGE__bgb8a9b6__","width":1648,"height":624,"format":"jpg"}